window.buttons3DInit = function buttons3DInit() {
  document.querySelectorAll('.btn').forEach((original) => {
    if (!original.classList.contains('is-init')) {
      const tagName = original.tagName.toLowerCase();
      const isLink = tagName === 'a';
      const isButton = tagName === 'button';

      const wrapper = document.createElement(isLink ? 'a' : 'button');
      wrapper.classList.add('btn-wr');

      const attrsToTransfer = ['href', 'target', 'type', 'onclick'];
      attrsToTransfer.forEach((attr) => {
        if (original.hasAttribute(attr)) {
          wrapper.setAttribute(attr, original.getAttribute(attr));
        }
      });

      const visualBtn = document.createElement('div');
      visualBtn.className = original.className;
      visualBtn.classList.add('is-init');

      const originalContent = original.innerHTML;

      visualBtn.innerHTML = originalContent;

      const btnBack = document.createElement('div');
      const btnFront = document.createElement('div');
      btnBack.classList.add('btn__back');
      btnFront.classList.add('btn__front');
      btnBack.innerHTML = originalContent;
      btnFront.innerHTML = originalContent;

      visualBtn.appendChild(btnBack);
      visualBtn.appendChild(btnFront);

      original.parentNode.insertBefore(wrapper, original);
      wrapper.appendChild(visualBtn);

      original.remove();
    }
  });
};

buttons3DInit();

// import { gsap } from 'gsap';

const followOnHover = (hovered, following) => {
  const onMouseMove = (event) => {
    const rect = hovered.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const circleWidth = following.offsetWidth;
    const circleHeight = following.offsetHeight;

    const offsetX = x - circleWidth / 2;
    const offsetY = y - circleHeight / 2;

    gsap.to(following, {
      duration: 0.05,
      x: offsetX,
      y: offsetY,
      ease: 'power2.out',
      opacity: 1,
      backgroundColor: 'var(--cl-blush)',
      borderColor: 'var(--cl-blush)',
    });
  };

  const removeMouseMove = () => {
    gsap.to(following, {
      duration: 0.1,
      opacity: 0,
    });
  };

  hovered.addEventListener('mousemove', onMouseMove);
  hovered.addEventListener('mouseleave', removeMouseMove);

  if (window.innerWidth < 1025) {
    hovered.removeEventListener('mousemove', onMouseMove);
    hovered.removeEventListener('mouseleave', removeMouseMove);
  }
};

window.hoverButton = followOnHover;

document.querySelectorAll('.btn-link').forEach((btn) => {
  const circle = btn.querySelector('.circle');
  followOnHover(btn, circle);
});

window.btnToTopFunc = function btnToTopFunc() {
  // селекторы (как у тебя)
  const btnToTop = document.querySelector('.btn-to-top');
  const btnToTopWr = document.querySelector('.btn-to-top-wr');
  const btnFollowingChatWr = document.querySelector('.btn-following-chat-wr');
  const btnOurWorkWr = document.querySelector('.btn-our-work-wr');
  const btnOurWorkMobWr = document.querySelector(
    '.home-first-sec .first-sec__buttons'
  );

  function ourWorkDistanceToWindowBottom() {
    let distanceToWindowBottom = 0;

    if (btnOurWorkMobWr) {
      const rect = btnOurWorkMobWr.getBoundingClientRect();
      distanceToWindowBottom = window.innerHeight - rect.bottom;
    }

    return distanceToWindowBottom;
  }

  // вспомогательная функция — получить left от .cont внутри обёртки
  function getContLeft(wrapper) {
    if (!wrapper) return 0;
    const cont = wrapper.querySelector('.cont');
    if (!cont) return 0;

    if (window.innerWidth >= 1100) {
      return cont.getBoundingClientRect().left;
    } else {
      const style = window.getComputedStyle(cont);
      return parseFloat(style.paddingLeft) || 0;
    }
  }

  // основная функция обновления позиций
  function updatePositions() {
    // -------------------------
    // 1) Старая логика для btnToTopWr (и для .btn-to-top по сути)
    //    — если есть только btnToTopWr, ей ставим bottom = leftOffset
    //    (тут мы не меняем логику, только переиспользуем getContLeft)
    // -------------------------
    if (btnFollowingChatWr) {
      const leftOffset = getContLeft(btnFollowingChatWr);
      btnFollowingChatWr.style.bottom = leftOffset + 'px';
    }

    // -------------------------
    // 2) Логика для btnOurWorkWr — НЕ ТРОГАЮ (оставил как было)
    // -------------------------
    if (btnOurWorkWr) {
      const cont = btnOurWorkWr.querySelector('.cont');
      if (cont) {
        const leftOffset = cont.getBoundingClientRect().left;
        /*btnOurWorkWr.style.paddingBottom = leftOffset + 'px';*/
      }
    }

    // -------------------------
    // 3) Новая логика для пары btnToTopWr и btnFollowingChatWr
    //    — меняем только bottom (не paddingBottom)
    //    — если есть 1 элемент: обычный bottom = leftOffset
    //    — если есть 2 элемента: считаем DOM-порядок
    //        second (тот, что позже в DOM) = нижний → даём обычный bottom
    //        first (тот, что раньше в DOM) = верхний → bottom = bottom_нижнего + высота_нижнего + 10
    // -------------------------
    const bottomCandidates = [btnToTopWr, btnFollowingChatWr].filter(Boolean);

    if (bottomCandidates.length === 1) {
      const el = bottomCandidates[0];
      const leftOffset = getContLeft(el);
      el.style.bottom = leftOffset + 'px';
    } else if (bottomCandidates.length === 2) {
      // определить порядок в DOM: first — тот, кто раньше в DOM, second — позже (нижний)
      let first = bottomCandidates[0];
      let second = bottomCandidates[1];

      // если first не предшествует second — поменяем
      if (
        !(
          first.compareDocumentPosition(second) &
          Node.DOCUMENT_POSITION_FOLLOWING
        )
      ) {
        first = bottomCandidates[1];
        second = bottomCandidates[0];
      }

      // нижнему — его обычный bottom
      const secondLeft = getContLeft(second);
      second.style.bottom = secondLeft + 'px';
      second.style.setProperty('--bottom', secondLeft + 'px');

      // вычисляем высоту нижнего (для сдвига верхнего)
      const secondRect = second.getBoundingClientRect();
      let shiftedBottom = secondLeft + secondRect.height + 10; // +10px как просил

      // верхнему — bottom от нижнего + высота нижнего + 10px

      if (first.classList.contains('btn-to-top-wr')) {
        if (btnFollowingChatWr && window.innerWidth > 1100) {
          shiftedBottom = shiftedBottom - 20;
        } else {
          shiftedBottom = secondLeft + secondRect.height + 10;
        }
      }
      first.style.bottom = shiftedBottom + 'px';
      first.style.setProperty('--bottom', shiftedBottom + 'px');
    }

    /*if (btnFollowingChatWr && window.innerWidth <= 1100) {
      btnFollowingChatWr.style.bottom = '10px';
      btnToTopWr.style.bottom = `${
        btnFollowingChatWr.clientHeight + 10 + 10
      }px`;
    } else {
      btnFollowingChatWr.style.bottom = '20px';
      btnToTopWr.style.bottom = `${
        btnFollowingChatWr.clientHeight + 10 + 20
      }px`;
    }*/
  }

  // первое применение и ресайз
  updatePositions();
  window.addEventListener('resize', updatePositions);

  if (!btnToTop) return;

  const toggleBtnClass = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const triggerPoint =
      window.innerWidth > 640
        ? window.innerHeight * 0.45
        : window.innerHeight * 0.1;

    if (scrollY >= triggerPoint) {
      btnToTop?.classList.add('is-active');
      btnFollowingChatWr?.classList.remove('is-inactive-btn-to-top');
      btnOurWorkMobWr?.classList.add('is-active-btn-to-top');

      if (btnToTopWr && btnFollowingChatWr) {
        const leftOffset = getContLeft(btnToTopWr);
        btnToTopWr.style.bottom = 52 + leftOffset + 10 + 'px';

        // setTimeout(() => {
        //   btnToTopWr.style.bottom =
        //     btnFollowingChatWr.clientHeight + leftOffset + 10 + 'px';
        // }, 450);

        if (window.innerWidth <= 1100 && window.innerWidth > 640) {
          btnFollowingChatWr.style.bottom = `20px`;
          btnToTopWr.style.bottom = `${
            btnFollowingChatWr.clientHeight + 20 + 10
          }px`;
        } else if (window.innerWidth <= 640) {
          btnFollowingChatWr.style.bottom = `16px`;
          btnToTopWr.style.bottom = `${
            btnFollowingChatWr.clientHeight + 10 + 20
          }px`;

          if (btnOurWorkMobWr) {
            btnFollowingChatWr?.style.setProperty(
              '--bottom-window',
              ourWorkDistanceToWindowBottom() + 'px'
            );
            btnFollowingChatWr?.classList.remove('is-bottom-window-distance');
          }
        }
      }
    } else {
      btnToTop?.classList.remove('is-active');
      btnFollowingChatWr?.classList.add('is-inactive-btn-to-top');
      btnOurWorkMobWr?.classList.remove('is-active-btn-to-top');

      if (btnOurWorkMobWr) {
        btnFollowingChatWr?.style.setProperty(
          '--bottom-window',
          ourWorkDistanceToWindowBottom() + 'px'
        );
        btnFollowingChatWr?.classList.add('is-bottom-window-distance');
      }
    }
  };

  $(btnToTop).on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 600);
  });

  toggleBtnClass();
  window.addEventListener('scroll', toggleBtnClass);
};

if (!document.querySelector('.bold-loader-new')) {
  btnToTopFunc();
}

window.btnCallFunc = function btnCallFunc() {
  const btnCall = document.querySelector('.btn-call');

  if (!btnCall) return;

  const toggleBtnClass = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const triggerPoint = window.innerHeight * 0.6;

    if (scrollY >= triggerPoint) {
      btnCall.classList.add('is-active');
    } else {
      btnCall.classList.remove('is-active');
    }
  };

  toggleBtnClass();
  window.addEventListener('scroll', toggleBtnClass);
};

if (!document.querySelector('.bold-loader-new')) {
  btnCallFunc();
}

window.dirControlBtnInit = function dirControlBtnInit() {
  document.querySelectorAll('.dir-control').forEach((el) => {
    if (el.dataset.dirInit) return;
    el.dataset.dirInit = '1';

    const text = el.innerHTML.trim();
    el.innerHTML = '';

    for (let i = 0; i < 4; i++) {
      const mask = document.createElement('span');
      mask.className = 'dir-control__mask';
      mask.dataset.index = String(i + 1);
      el.appendChild(mask);
    }

    for (let i = 0; i < 4; i++) {
      const b = document.createElement('b');
      b.setAttribute('aria-hidden', 'true');
      b.innerHTML = text;
      el.appendChild(b);
    }

    const label = document.createElement('span');
    label.className = 'dir-control__label';
    label.innerHTML = text;
    el.appendChild(label);

    let activeIndex = null;

    function clearActive() {
      activeIndex = null;
      el.querySelectorAll('.dir-control__mask.active').forEach((n) =>
        n.classList.remove('active')
      );
      el.querySelectorAll('b.active').forEach((n) =>
        n.classList.remove('active')
      );
    }

    function sectorIndexFromEvent(ev) {
      const rect = el.getBoundingClientRect();
      const x = ev.clientX - rect.left;
      const y = ev.clientY - rect.top;

      const w = rect.width;
      const h = rect.height;

      const cx = w / 2;
      const cy = h / 2;

      const dx = x - cx;
      const dy = y - cy;

      if (Math.abs(dx) > Math.abs(dy)) {
        return dx > 0 ? 2 : 4;
      } else {
        return dy > 0 ? 3 : 1;
      }
    }

    function setActive(idx) {
      if (activeIndex === idx) return;

      clearActive();

      const mask = el.querySelector(`.dir-control__mask[data-index="${idx}"]`);
      const b = el.querySelector(`b:nth-of-type(${idx})`);
      if (mask) mask.classList.add('active');
      if (b) b.classList.add('active');

      activeIndex = idx;
    }

    el.addEventListener('mouseenter', (e) => {
      const idx = sectorIndexFromEvent(e);
      setActive(idx);
    });

    /*el.addEventListener('mousemove', (e) => {
    });*/

    el.addEventListener('mouseleave', () => {
      clearActive();
    });

    el.addEventListener('click', () => {
      try {
        el.animate(
          [
            { transform: getComputedStyle(el).transform },
            { transform: 'translateY(0) scale(1)' },
            { transform: getComputedStyle(el).transform },
          ],
          { duration: 140, easing: 'linear' }
        );
      } catch {}
    });
  });
};

dirControlBtnInit();

window.btnChatAnimationsFunc = function btnChatAnimationsFunc() {
  const btnChatWr = document.querySelector('.btn-following-chat-wr');
  const firstOurWorkBtn = document.querySelector(
    '.first-sec__buttons .dir-control-btn'
  );
  const ourWorkBtn = document.querySelector(
    '.btn-our-work-wr .dir-control-btn'
  );

  if (!btnChatWr) return;

  if (!document.querySelector('.bold-loader-new')) {
    setTimeout(function () {
      btnChatWr.classList.add('is-internal-page');
    }, 300);
  }

  const btnChat = btnChatWr.querySelector('.following-chat-btn');

  // стартовое состояние
  /*btnChat.classList.add('is-chat-start-size');*/
  ourWorkBtn?.classList.add('is-chat-btn-start-animation');
  firstOurWorkBtn?.classList.add('is-chat-btn-start-animation');
  btnChatWr.classList.add('is-chat-btn-start-animation');
  btnChatWr.classList.add('is-init-chat-btn');

  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (window.scrollY >= 130) {
          ourWorkBtn?.classList.remove('is-chat-btn-start-animation');
          firstOurWorkBtn?.classList.remove('is-chat-btn-start-animation');
          btnChatWr.classList.remove('is-chat-btn-start-animation');
          btnChat.classList.add('is-small-size');
        } else {
          ourWorkBtn?.classList.add('is-chat-btn-start-animation');
          firstOurWorkBtn?.classList.add('is-chat-btn-start-animation');
          btnChatWr.classList.add('is-chat-btn-start-animation');
          btnChat.classList.remove('is-small-size');
        }
        ticking = false;
      });
      ticking = true;
    }
  });
};

if (!document.querySelector('.bold-loader-new')) {
  btnChatAnimationsFunc();
}
